import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const params = useParams();

  useEffect(() => {
    const paramKeys = Object.keys(params);
    if (paramKeys.includes('dealId')) {
      return;
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto',
    });
  }, [pathname]);

  return <div />;
}
